import mapboxgl from 'mapbox-gl';

// TODO: Add other map view helpers

/**
 * Returns the current view of the map
 */
const getCurrentView = map => {
  const [[w, s], [e, n]] = map.getBounds().toArray();
  return {
    bbox: [w, s, e, n],
    zoom: Math.floor(map.getZoom())
  };
};

/**
 * Automatically zooms and pans the map to the bounds of the geojson data
 */
const flyToView = (geojsonData, mapInstance, setProgrammaticMove, pipelineViewEnabled) => {
  var _geojsonData$features;
  if (!(geojsonData !== null && geojsonData !== void 0 && (_geojsonData$features = geojsonData.features) !== null && _geojsonData$features !== void 0 && _geojsonData$features.length) || !mapInstance) return;
  const bounds = new mapboxgl.LngLatBounds();
  geojsonData.features.forEach(f => {
    var _f$geometry;
    if (f !== null && f !== void 0 && (_f$geometry = f.geometry) !== null && _f$geometry !== void 0 && _f$geometry.coordinates) {
      bounds.extend(f.geometry.coordinates);
    }
  });
  if (!bounds.isEmpty()) {
    if (setProgrammaticMove) {
      setProgrammaticMove(true);
    }
    mapInstance.fitBounds(bounds, {
      padding: 20,
      duration: 1000,
      maxZoom: pipelineViewEnabled ? 12 : 3
    });
  }
};
export { flyToView, getCurrentView };